import { render, staticRenderFns } from "./UserCenter.vue?vue&type=template&id=55c8797e&scoped=true"
import script from "./UserCenter.vue?vue&type=script&lang=ts"
export * from "./UserCenter.vue?vue&type=script&lang=ts"
import style0 from "./UserCenter.vue?vue&type=style&index=0&id=55c8797e&prod&lang=scss&scoped=true"
import style1 from "./UserCenter.vue?vue&type=style&index=1&id=55c8797e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c8797e",
  null
  
)

export default component.exports